import './gaslightevents/style';
import FormStructure from './gaslightevents/form_structure';

export default FormStructure;